/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Role, Role$inboundSchema } from "./role.js";

export type ListRolesResult = {
  /**
   * The roles in your organization.
   */
  roles: Array<Role>;
};

/** @internal */
export const ListRolesResult$inboundSchema: z.ZodMiniType<
  ListRolesResult,
  unknown
> = z.object({
  roles: z.array(Role$inboundSchema),
});

export function listRolesResultFromJSON(
  jsonString: string,
): SafeParseResult<ListRolesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListRolesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListRolesResult' from JSON`,
  );
}
